"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _components = require("@engaging-tech/components");
var _excluded = ["color"];
var AnimatedStarIcon = function AnimatedStarIcon(_ref) {
  var color = _ref.color,
    props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var animateVariant = {
    rotate: [0, -30, 380, 360],
    transition: {
      duration: 4,
      times: [0, 0.1, 0.95, 1],
      repeat: Infinity,
      repeatDelay: 10,
      ease: "easeInOut",
      type: "spring",
      delay: 3
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_components.Flex, (0, _extends2["default"])({
    width: 20,
    height: 20
  }, props), /*#__PURE__*/_react["default"].createElement(_components.MotionFlex, {
    animate: animateVariant
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    name: "stars",
    color: color
  })));
};
var _default = exports["default"] = AnimatedStarIcon;